import { render } from "./ModalYoutube.vue?vue&type=template&id=5fc0ae00"
import script from "./ModalYoutube.vue?vue&type=script&lang=js"
export * from "./ModalYoutube.vue?vue&type=script&lang=js"

import "./ModalYoutube.vue?vue&type=style&index=0&id=5fc0ae00&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__